import { Injectable } from '@angular/core';
import { GenericFormField } from './model/generic-field';
import {
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { GenericValidator } from './model/generic-validator';
import { ValidationConverterService } from '../services/validation-converter.service';
import { ControlTypes } from './enums/control-types';
import { coerceToBoolean } from '../utils/value-utils';

@Injectable({
  providedIn: 'root',
})
export class GenericFormService {
  constructor(private validationConverter: ValidationConverterService) {}
    toFormGroup(fields: GenericFormField[]) {
        const group: any = {};
        for (const field of fields) {
            const validators = this.generateValidators(field.validators);
            if (field.required && !validators.some(v => v === Validators.required)) {
                validators.unshift(Validators.required);
            }

            let controlValue: any = field.value ?? '';
            if (field.controlType === ControlTypes.Checkbox) {
              controlValue = coerceToBoolean(controlValue);
              field.value = controlValue;
            }

            group[field.key] = new FormControl(controlValue, validators);
        }
        const formGroup = new FormGroup(group);

        this.setupCrossFieldValidation(fields, formGroup);

        return formGroup;
    }

  // checkbox normalization now uses shared coerceToBoolean

  public generateValidators(validators: GenericValidator[]) {
    for (const validator of validators) {
      switch (validator.key) {
        case 'email':
          validator.message = validator.message || 'DefaultErrorEmail';
          break;
        case 'max':
          validator.message = validator.message || 'DefaultErrorMax';
          break;
        case 'maxlength':
          validator.message = validator.message || 'DefaultErrorMaxLength';
          break;
        case 'min':
          validator.message = validator.message || 'DefaultErrorMin';
          break;
        case 'minlength':
          validator.message = validator.message || 'DefaultErrorMinLength';
          break;
        case 'pattern':
          validator.message = validator.message || 'DefaultErrorPattern';
          break;
        case 'required':
          validator.message = validator.message || 'DefaultErrorRequired';
          break;
        case 'requiredtrue':
          validator.message = validator.message || 'DefaultErrorRequired';
          break;
        case 'decimal':
          validator.message = validator.message || 'InvalidDecimalFormat';
          break;
        case 'time':
          validator.message = validator.message || 'InvalidTimeFormat';
          break;
        case 'date':
          validator.message = validator.message || 'InvalidDateFormat';
          break;
        case 'equalOrLessThanField':
          validator.message = validator.message || 'MustBeEqualOrLessThan';
          break;
        case 'lessThanField':
          validator.message = validator.message || 'MustBeLessThan';
          break;
        case 'equalOrGreaterThanField':
          validator.message = validator.message || 'MustBeEqualOrGreaterThan';
          break;
        case 'greaterThanField':
          validator.message = validator.message || 'MustBeGreaterThan';
          break;
        default:
          break;
      }
    }

    return this.validationConverter.toAngularValidators(validators);
  }

  private setupCrossFieldValidation(fields: GenericFormField[], formGroup: FormGroup): void {
    for (const field of fields) {
      const control = formGroup.controls[field.key];
      if (!control) continue;

      for (const validator of field.validators ?? []) {
        if (validator.key === 'lessThanField' || validator.key === 'greaterThanField' || validator.key === 'equalOrLessThanField' || validator.key === 'equalOrGreaterThanField') {
          const relatedFieldKey = validator.value;
          const relatedControl = formGroup.controls[relatedFieldKey];

          if (relatedControl) {
            relatedControl.valueChanges.subscribe(() => {
              control.updateValueAndValidity({ emitEvent: false });
            });
          }
        }
      }
    }
  }
}
